import { findLayeredTextRelationAndLayerByDocumentId } from 'modules/draftjs2lexical';
import * as Models from 'models';

export function getApplicableForTextCompnentFirstLayeredRelationStyles(
  textComponentId: string,
  layeredRelations: Models.LayeredRelationsMap,
): Models.TextRelationStyles | null {
  const relationAndLayer = findLayeredTextRelationAndLayerByDocumentId(layeredRelations, textComponentId);
  if (!relationAndLayer) {
    return null;
  }
  const [relation, layer] = relationAndLayer;
  const styles = relation.getIn(['styles', layer])?.toJS() as Models.TextRelationStyles;

  return styles ?? null;
}
